
interface Screen {
  id: string;
  name: string;
  elements: unknown[];
}

interface ScreenManagerProps {
  screens: Screen[];
  activeScreenId: string;
  onSelectScreen: (id: string) => void;
  onAddScreen: () => void;
  onDeleteScreen: (id: string) => void;
  onRenameScreen: (id: string, name: string) => void;
}

export default function ScreenManager({
  screens,
  activeScreenId,
  onSelectScreen,
  onAddScreen,
  onDeleteScreen,
  onRenameScreen,
}: ScreenManagerProps) {
  return (
    <div className="border-b border-gray-200 bg-gray-50 px-4 py-2 flex items-center gap-2 overflow-x-auto">
      <span className="text-xs font-bold text-gray-500 uppercase tracking-wide whitespace-nowrap mr-1">Screens</span>
      {screens.map((screen) => (
        <div
          key={screen.id}
          onClick={() => onSelectScreen(screen.id)}
          className={`group flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium cursor-pointer transition-all whitespace-nowrap ${
            activeScreenId === screen.id
              ? 'bg-teal-500 text-white shadow-md'
              : 'bg-white border border-gray-200 text-gray-600 hover:border-teal-300 hover:text-teal-600'
          }`}
        >
          <i className="ri-smartphone-line text-sm"></i>
          <span
            contentEditable
            suppressContentEditableWarning
            onBlur={(e) => onRenameScreen(screen.id, e.currentTarget.textContent || screen.name)}
            onClick={(e) => e.stopPropagation()}
            className="outline-none min-w-[40px]"
          >
            {screen.name}
          </span>
          {screens.length > 1 && (
            <button
              onClick={(e) => { e.stopPropagation(); onDeleteScreen(screen.id); }}
              className={`w-4 h-4 flex items-center justify-center rounded-full transition-all cursor-pointer ${
                activeScreenId === screen.id
                  ? 'hover:bg-white/20 text-white/80 hover:text-white'
                  : 'opacity-0 group-hover:opacity-100 hover:bg-red-100 text-gray-400 hover:text-red-500'
              }`}
            >
              <i className="ri-close-line text-xs"></i>
            </button>
          )}
        </div>
      ))}
      <button
        onClick={onAddScreen}
        className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium text-gray-500 hover:text-teal-600 hover:bg-teal-50 border border-dashed border-gray-300 hover:border-teal-400 transition-all cursor-pointer whitespace-nowrap"
      >
        <i className="ri-add-line text-sm"></i>
        Add Screen
      </button>
    </div>
  );
}
